<template>
  <div class="form-usuario-wrapper">
    <v-form ref="form" v-model="formValido" class="dark-form">
      <div class="field">
        <label class="field-label">Nombre de usuario</label>
        <v-text-field
          v-model="usuario.usuario"
          :rules="reglas"
          required
          hide-details="auto"
          outlined
          dense
          placeholder="Ej. jgarcia"
          class="dark-input"
        ></v-text-field>
      </div>

      <div class="field">
        <label class="field-label">Nombre completo</label>
        <v-text-field
          v-model="usuario.nombre"
          :rules="reglas"
          required
          hide-details="auto"
          outlined
          dense
          placeholder="Ej. Juan García"
          class="dark-input"
        ></v-text-field>
      </div>

      <div class="field">
        <label class="field-label">Teléfono</label>
        <v-text-field
          v-model="usuario.telefono"
          :rules="reglas"
          required
          hide-details="auto"
          outlined
          dense
          placeholder="Ej. 3531015780"
          class="dark-input"
        ></v-text-field>
      </div>

      <div class="field">
        <label class="field-label">Rol</label>
        <v-select
          v-model="usuario.rol"
          :items="rolesDisponibles"
          item-text="label"
          item-value="value"
          outlined
          dense
          hide-details="auto"
          placeholder="Selecciona un rol"
          class="dark-input"
        />
      </div>
    </v-form>

    <div class="form-actions">
      <button class="btn-ghost" @click="$router.push({ name: 'Usuarios' })">Cancelar</button>
      <button class="btn-primary" :disabled="!formValido" @click="registrar">Registrar</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "FormUsuario",
  props: ["usuario"],
  data: () => ({
    formValido: false,
    formHasErrors: false,
    reglas: [(value) => !!value || "Campo obligatorio."],
    rolesDisponibles: [
      { label: "Administrador", value: "admin" },
      { label: "Empleado", value: "empleado" }
      //{ label: "Instructor", value: "instructor" },
      //{ label: "Ventas", value: "ventas" }
    ],
  }),

  mounted() {
    this.formValido = false;
    if (this.usuario && !this.usuario.rol) {
      this.$set(this.usuario, 'rol', '');
    }
  },

  methods: {
    registrar() {
      this.formHasErrors = false;

      if (!this.usuario) {
        console.error("🚨 this.usuario no está definido");
        return;
      }

      const campos = this.form;
      for (const campo in campos) {
        if (!campos[campo]) {
          this.formHasErrors = true;
        }
      }

      if (!this.formHasErrors) {
        console.log("✅ Usuario a registrar:", this.usuario);
        this.$emit("registrado", this.usuario);
        this.formValido = false;
      } else {
        console.warn("❌ Formulario con errores:", campos);
      }
    }
    ,
  },
  computed: {
    form() {
      return {
        usuario: this.usuario && this.usuario.usuario ? this.usuario.usuario : '',
        nombre: this.usuario && this.usuario.nombre ? this.usuario.nombre : '',
        telefono: this.usuario && this.usuario.telefono ? this.usuario.telefono : '',
        rol: this.usuario && this.usuario.rol ? this.usuario.rol : ''
      }
    }

  }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');

.form-usuario-wrapper {
  --bg: #0E0E10;
  --card: #17171A;
  --card-border: #26262A;
  --text-primary: #F2F2ED;
  --text-secondary: #8C8C93;
  --text-tertiary: #5C5C62;
  --accent: #C8FF4D;
  --error: #FF6B6B;
  --radius: 4px;

  --font-body: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
  font-family: var(--font-body);
}

.dark-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.field {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.field-label {
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.02em;
  color: var(--text-secondary);
  text-transform: uppercase;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 22px;
  padding-top: 20px;
  border-top: 1px solid var(--card-border);
}

.btn-primary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--accent);
  color: var(--bg);
  border: none;
  border-radius: var(--radius);
  padding: 10px 18px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: filter 0.15s ease;
}

.btn-primary:hover:not(:disabled) {
  filter: brightness(1.08);
}

.btn-primary:disabled {
  opacity: 0.45;
  cursor: default;
}

.btn-ghost {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  color: var(--text-secondary);
  border: 1px solid var(--card-border);
  border-radius: var(--radius);
  padding: 10px 18px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: border-color 0.15s ease, color 0.15s ease;
}

.btn-ghost:hover {
  border-color: var(--text-tertiary);
  color: var(--text-primary);
}

/* ===== Overrides v-text-field / v-select (Vuetify) ===== */
.dark-input >>> .v-input__slot {
  background: var(--bg) !important;
  border-radius: 4px !important;
  box-shadow: none !important;
  min-height: 42px !important;
}

.dark-input >>> fieldset {
  border-color: var(--card-border) !important;
  border-width: 1px !important;
  border-radius: 4px !important;
  transition: border-color 0.15s ease;
}

.dark-input >>> .v-input--is-focused fieldset {
  border-color: var(--accent) !important;
  border-width: 1.5px !important;
}

.dark-input >>> input,
.dark-input >>> .v-select__selection {
  color: var(--text-primary) !important;
  font-family: var(--font-body) !important;
  font-size: 14px !important;
  caret-color: var(--accent) !important;
}

.dark-input >>> input::placeholder {
  color: var(--text-tertiary) !important;
  opacity: 1 !important;
}

.dark-input >>> .v-select__selection--comma {
  color: var(--text-primary) !important;
}

.dark-input >>> .v-text-field__placeholder {
  color: var(--text-tertiary) !important;
}

.dark-input >>> .v-icon {
  color: var(--text-tertiary) !important;
}

.dark-input >>> .v-messages {
  color: var(--error) !important;
}

/* Menú del v-select */
.form-usuario-wrapper >>> .v-menu__content {
  background: var(--card) !important;
  border: 1px solid var(--card-border) !important;
  border-radius: 4px !important;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.5) !important;
}

.form-usuario-wrapper >>> .v-list {
  background: transparent !important;
  padding: 4px !important;
}

.form-usuario-wrapper >>> .v-list-item {
  border-radius: 4px !important;
}

.form-usuario-wrapper >>> .v-list-item__title {
  color: var(--text-primary) !important;
  font-family: var(--font-body) !important;
  font-size: 13.5px !important;
}

.form-usuario-wrapper >>> .v-list-item:hover {
  background: rgba(255, 255, 255, 0.04) !important;
}

.form-usuario-wrapper >>> .v-list-item--active {
  background: rgba(200, 255, 77, 0.12) !important;
}

.form-usuario-wrapper >>> .v-list-item--active .v-list-item__title {
  color: var(--accent) !important;
}

@media (max-width: 600px) {
  .form-actions {
    flex-direction: column-reverse;
  }

  .form-actions .btn-primary,
  .form-actions .btn-ghost {
    width: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Usuarios/FormUsuario.vue